import { TotalProductEmissionAnnual } from 'models/TotalProductEmissionAnnual/totalProductEmissionAnnual.model';
import { ApiRoutes } from 'routes/routeConstants/apiRoutes';
import { EmissionParams } from 'services/DashboardService/dashboard.service';
import { CategoryOptions } from '.';
import { ProductEmission } from 'models/ProductEmission/productEmission.model';
import { EmissionState } from './index';
import { SortKeys } from 'enums/GraphDropdownEnums';

export const handleChangeBusinessModelProductEmission = (
  params: EmissionParams,
  setSortedProductEmissionList: React.Dispatch<React.SetStateAction<EmissionState>>,
  fetchProductEmission: (params: EmissionParams) => void
) => {
  setSortedProductEmissionList(prev => ({ ...prev, params: params }));
  fetchProductEmission(params);
};

export const handleChangeBusinessModelAnnualEmission = (
  params: EmissionParams,
  setSortedAnnualEmissionList: React.Dispatch<React.SetStateAction<EmissionState>>,
  fetchProductEmissionAnnual: (params: EmissionParams) => void
) => {
  setSortedAnnualEmissionList(prev => ({ ...prev, params: params }));
  fetchProductEmissionAnnual(params);
};

export const downloadProductEmissionCSV = (
  downloadGraph: (url: string, params: EmissionParams) => void,
  sortedProductEmissionList: { params: EmissionParams }
) => {
  downloadGraph(ApiRoutes.FETCH_PRODUCT_EMISSION, sortedProductEmissionList.params);
};

export const downloadAnnualEmissionCSV = (
  downloadGraph: (url: string, params: EmissionParams) => void,
  sortedAnnualEmissionList: { params: EmissionParams }
) => {
  downloadGraph(ApiRoutes.FETCH_PRODUCT_EMISSION_ANNUAL, sortedAnnualEmissionList.params);
};

export const handleSortProductEmission = (
  key: string,
  sortedProductEmissionList: EmissionState,
  setSortedProductEmissionList: (value: EmissionState) => void,
  handleFetchEmission: (
    params: EmissionParams,
    productsEmission?: boolean,
    annualEmission?: boolean
  ) => void
) => {
  const updatedValue: EmissionState = {
    ...sortedProductEmissionList,
    params: {
      ...sortedProductEmissionList.params,
      is_asc:
        key === SortKeys.VALUE_LOW_TO_HIGH
          ? true
          : key === SortKeys.VALUE_HIGH_TO_LOW
            ? false
            : undefined,
    },
  };
  setSortedProductEmissionList(updatedValue);
  handleFetchEmission(updatedValue.params, true, false);
};

export const handleSortAnnualEmission = (
  key: string,
  sortedAnnualEmissionList: EmissionState,
  setSortedAnnualEmissionList: (value: EmissionState) => void,
  handleFetchEmission: (
    params: EmissionParams,
    productsEmission?: boolean,
    annualEmission?: boolean
  ) => void
) => {
  const updatedValue: EmissionState = {
    ...sortedAnnualEmissionList,
    params: {
      ...sortedAnnualEmissionList.params,
      is_asc:
        key === SortKeys.VALUE_LOW_TO_HIGH
          ? true
          : key === SortKeys.VALUE_HIGH_TO_LOW
            ? false
            : undefined,
    },
  };
  setSortedAnnualEmissionList(updatedValue);
  handleFetchEmission(updatedValue.params, false, true);
};

/**Chart 2 calculations */
export const convertToOptionsAnnual = (data: TotalProductEmissionAnnual[]) => {
  const options: CategoryOptions[] = [];
  data?.map((item: TotalProductEmissionAnnual) => {
    const emission =
      typeof item.totalValue === 'number'
        ? parseFloat(item.totalValue.toFixed(2))
        : undefined;
    options.push({
      name: item.name,
      emission: emission,
      key: item.id,
    });
  });

  return options;
};

export const convertToOptions = (data: ProductEmission[]) => {
  const options: CategoryOptions[] = [];
  data?.forEach((item: ProductEmission) => {
    const emission =
      typeof item.b2c === 'number'
        ? parseFloat(item.b2c.toFixed(2))
        : undefined;
    options.push({
      name: item.name,
      emission: emission,
      key: item.id,
    });
  });

  return options;
};
